import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/_n/fonts/Figtree-Regular.woff2%22,%22weight%22:%22400%22},{%22path%22:%22../public/_n/fonts/Figtree-Medium.woff2%22,%22weight%22:%22500%22},{%22path%22:%22../public/_n/fonts/Figtree-SemiBold.woff2%22,%22weight%22:%22600%22}],%22preload%22:true,%22display%22:%22swap%22,%22variable%22:%22--font-figtree%22,%22fallback%22:[%22Helvetica%20Neue%22,%22Helvetica%22,%22Arial%22,%22sans-serif%22]}],%22variableName%22:%22figtreeFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'figtreeFont', 'figtreeFont Fallback', Helvetica Neue, Helvetica, Arial, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
